import React, { useEffect, useState } from 'react'
import { Autocomplete, useObservable } from '@cicero/ui'
import { IFormElementProps, createSyntheticChangeEvent, useAutocompleteConfig } from '@cicero/ui/forms'
import { of } from 'rxjs'
import { PageTemplateDoc, PageTemplateSchema, useModel } from 'models'

interface IPageChooserProps extends IFormElementProps<PageTemplateSchema|string|null> {
  label?: string
  alwaysOpen?: boolean
  autoFocus?: boolean
}

export const TemplateChooser = ({ name, value, onChange, ...restOfParams }: IPageChooserProps) => {
  const Templates = useModel(PageTemplateSchema)
  const [options, setOptions] = useState<PageTemplateSchema[]>([])

  useEffect(() => {
    const sub = Templates.QUERY$({ selector: {} })
      .subscribe(templates => {
        setOptions(templates)
      })
    return () => sub.unsubscribe()
  }, [])

  useEffect(() => {
    if (typeof value === 'string') {
      const opt = options.find(o => o.id === value)
      if (opt) { onChange(createSyntheticChangeEvent(name, opt)) }
    }
  }, [value, options])

  return <Autocomplete
    {...useAutocompleteConfig(restOfParams)}
    autoComplete={false}
    value={value as any}
    options={options}
    getOptionLabel={(template: PageTemplateSchema) => typeof template === 'string' ? '' : template?.name}
    onChange={(event, newVal) => {
      onChange(createSyntheticChangeEvent(name, newVal))
    }}
  />
}

export const TemplateIdRenderer = ({ id }: { id?: string }) => {
  const Templates = useModel(PageTemplateSchema)
  const template = useObservable(() => id ? Templates.GET$(id) : of(null), null, [id])

  return template ? <TemplateRenderer template={template} /> : null
}

export const TemplateRenderer = ({ template }: { template: PageTemplateDoc }) => {
  return <span>{template.name}</span>
}
